'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

import { esRutaTableroPaciente } from '@/components/tablero/rutasTablero';
import { useDeferredMount } from '@/lib/perf/useDeferredMount';

// Design D5 #3 (sdd/seo-audit-remediation): these four components mount on
// every page from the root layout and account for the 276 KiB of unused JS
// measured on the homepage. `next/dynamic` keeps them out of the initial
// bundle; `useDeferredMount` additionally delays instantiating them until the
// browser is idle or the user first interacts. `ssr: false` requires this to
// live in a client component — RootLayout stays a server component and only
// renders this wrapper.
const AnalyticsWrapper = dynamic(
    () => import('@/components/cookie-consent/AnalyticsWrapper').then((m) => m.AnalyticsWrapper),
    { ssr: false }
);
const CookieBanner = dynamic(
    () => import('@/components/cookie-consent/CookieBanner').then((m) => m.CookieBanner),
    { ssr: false }
);
const ChatbotBubble = dynamic(
    () => import('@/components/marketing/help/ChatbotBubble').then((m) => m.ChatbotBubble),
    { ssr: false }
);
const BetaFeedbackBubble = dynamic(
    () => import('@/components/marketing/help/BetaFeedbackBubble').then((m) => m.BetaFeedbackBubble),
    { ssr: false }
);

export function DeferredWidgets() {
    const ready = useDeferredMount();
    // D-09: the patient board carries its own assistant, and these fixed bubbles sat on top of
    // its controls (the compact bar's send button at 768). Beta feedback stays reachable there
    // through the avatar menu's «Feedback» entry.
    const sinBurbujas = esRutaTableroPaciente(usePathname());

    return (
        <>
            {/* The consent notice is deliberately NOT deferred. Waiting for idle
                left the page without a cookie notice for up to 4s, and the banner
                is both light and the thing that unlocks analytics — deferring it
                bought no measurable performance while weakening the consent flow.
                AnalyticsWrapper stays behind the gate: it renders nothing until
                consent has been answered, so nothing is tracked early either way. */}
            <CookieBanner />
            {ready && (
                <>
                    <AnalyticsWrapper />
                    {!sinBurbujas && <ChatbotBubble />}
                    {!sinBurbujas && <BetaFeedbackBubble />}
                </>
            )}
        </>
    );
}
